import React, { FC, useMemo } from 'react';
import styled from 'styled-components';

import {
  useAbstractEditor,
  List as PermissionList,
  connect as connectPermissions
} from './index';
import { SliderItem } from './SliderItem';
import { translations } from 'i18n';
import App from '../../../models/app';
import { GalleryAppPermissions } from './types';

const EditorContainer = styled.div`
  width: 100%;
`;

const MockContainer = styled.div``;

export interface PermissionsEditorProps {
  app: App;
  permissions: GalleryAppPermissions;
  onChange: (permissions: GalleryAppPermissions) => void;
}

const PermissionsEditor: FC<PermissionsEditorProps> = ({ app, permissions, onChange }) => {
  const {
    comms: { permissions: permissionsText }
  } = translations;

  const {
    permissions: localPermissions,
    visiblePermissions,
    setPermission,
    setAllPermissions,
  } = useAbstractEditor({ app, permissions, onChange });

  const areAllPermissionsOn = useMemo(() => {
    for (const name of visiblePermissions) {
      if (localPermissions[name] === false) {
        return false;
      }
    }
    return true;
  }, [visiblePermissions, localPermissions]);

  return (
    <EditorContainer>
      <SliderItem
        checked={areAllPermissionsOn}
        hideBottomBorder={true}
        item={{
          description: permissionsText._toggle_all.description(),
          isNew: true,
          title: permissionsText._toggle_all.label(),
          value: 'toggle-all',
          id: 'toggle-all',
        }}
        onChange={() => setAllPermissions(!areAllPermissionsOn)}
      />
      <PermissionList
        containerComponent={MockContainer}
        itemComponent={SliderItem}
        newPermissions={app.newPermissions}
        permissions={localPermissions}
        permissionAlerts={app.osPermissionsEnableableMap}
        visiblePermissions={visiblePermissions}
        onChange={setPermission}
      />
    </EditorContainer>
  );
};

export default connectPermissions(PermissionsEditor);
